module.exports = __webpack_public_path__ + "static/media/live_music_online.39ff8127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/live_music_online.jpg
// module id = 1270
// module chunks = 0